import { render, staticRenderFns } from "./WsAmountCard001.vue?vue&type=template&id=b0cc71ee"
import script from "./WsAmountCard001.vue?vue&type=script&lang=js"
export * from "./WsAmountCard001.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports